import { PartnerProgramService } from '@/services/partner-program.service';
import useCurrencyStore from '@/store/useCurrencyStore';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export function useFetchPartners(productId: string, enabled = true) {
  const [page, setPage] = useState(1);
  const [onlyActive] = useState(true);
  const currency = useCurrencyStore((s) => s.currency);

  const { data, isLoading, refetch, isRefetching } = useQuery({
    queryKey: ['partner-program-partners', productId, page, onlyActive, currency],
    queryFn: () =>
      PartnerProgramService.listPartners(productId, {
        only_active: onlyActive,
        per_page: 15,
        page,
        currency,
      }),
    enabled: !!productId && enabled,
    staleTime: 15 * 1000,
  });

  return {
    partnersData: data ?? null,
    isLoading: isLoading || isRefetching,
    page,
    setPage,
    onlyActive,
    refetch,
  };
}
